<div mat-dialog-title class="flex column" style="background-color: #0c5daa; border-bottom: 1px solid white; margin-bottom: 5px; height: 60px;">
  <p style="font-size: larger !important; color: white !important; font-weight: 600; margin-top: -25px;">
    {{title}}
  </p>
</div>
  
<mat-dialog-content class="scrollable-content">
  <div class="flex center sticky-container">
    <ng-container *ngIf="contentTemplate">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </ng-container>
  </div>
</mat-dialog-content>
    
<mat-dialog-actions align="end">
    <!-- <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button> -->
    <ng-container *ngIf="buttonTemplate">
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </ng-container>

    <button mat-raised-button color="primary" style="background-color: #0c5daa;" (click)="onSubmit()" [disabled]="loading">
      <span *ngIf="!loading">{{buttonText}}</span>
    </button>
</mat-dialog-actions>